import React, { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { RenderProductFruits } from 'components/product-fruits'
// eslint-disable-next-line max-len
import { useUserIntentionQualification } from 'components/product-fruits/user-intention-qualification/use-user-intention'
import { APP_ROUTES } from '../../app/routes/routes.constants'

import { Header } from './header'
import { Sidemenu, SidemenuContext } from './sidemenu'
import { useShowSideMenuBasedOnRouteChanges } from './sidemenu/hooks'
import * as PlatformManagerContext from './platform-manager.context'
import { Content } from './content'

function shouldHideStructureComp(pathname) {
  return [APP_ROUTES.notFound, ...Object.values(APP_ROUTES.password)].includes(pathname)
}

function showHeaderByRoute(pathname) {
  return ![APP_ROUTES.onboarding, '/age-limit'].includes(pathname)
}

interface StructureProps {
  children: ReactNode
}

const Structure = (props: StructureProps) => {
  const location = useLocation()

  const { productFruitsUserIntentionQualification } = useUserIntentionQualification()

  const showHeader = showHeaderByRoute(location.pathname)
  const showSideMenu = useShowSideMenuBasedOnRouteChanges()

  return shouldHideStructureComp(location.pathname) ? null : (
    <SidemenuContext.Provider>
      <PlatformManagerContext.Provider>
        {productFruitsUserIntentionQualification && <RenderProductFruits />}
        <hot-toast />
        {showHeader && <Header />}
        <main className="bw__main">
          {showSideMenu && <Sidemenu />}
          <Content>{props.children}</Content>
        </main>
      </PlatformManagerContext.Provider>
    </SidemenuContext.Provider>
  )
}

export default React.memo(Structure)
